module.exports = __webpack_public_path__ + "static/media/container5.0bae4264.jpg";